var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-profile-collection"},[(_vm.users.length > 0)?_vm._l((_vm.users),function(user,index){return _c('div',{key:user.id,staticClass:"user-photo",style:({ 
        backgroundImage: `url(${(user.photo) ? user.photo : _vm.person})`,
        left: `${index * 20}px`            
      }),attrs:{"title":user.name,"id":'olivertooltip-' + index,"data-toggle":"tooltip"}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }